import * as constants from '../constants/actions';

const initialState = {
  menuOpen: false,
  menuSubmenu: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.HEADER_TOGGLE:
      return headerToggle(state, action);
    case constants.HEADER_SUBMENU:
      return headerSubmenu(state, action);
    default:
      return state;
  }
}

function headerToggle(state, action) {
  const nextState = !state.menuOpen;
  return Object.assign({}, state, {
    menuOpen: nextState,
    menuSubmenu: null,
  });
}

function headerSubmenu(state, action) {
  return Object.assign({}, state, {
    menuSubmenu: action.submenu,
  });
}



// WEBPACK FOOTER //
// ./src/reducers/header.jsx